(function () {
    'use strict';

    angular.module('handbookApp')
        .controller('DocumentController', documentController);

    documentController.$inject = ['$scope', '$rootScope', '$http', '$stateParams', '$state', '$sce', '$location', '$anchorScroll', '$timeout', '$filter', '$uibModal',
        'broadcastService', 'documentService', 'favoriteService', 'tabStateService', 'anchorService', 'documentContentsSearchService',
        'resizeService', 'localStorageService', 'folderService', 'treeNavigationService', '$q', 'configService', 'browserService'];

    function documentController($scope, $rootScope, $http, $stateParams, $state, $sce, $location, $anchorScroll, $timeout, $filter, $uibModal,
        broadcastService, documentService, favoriteService, tabStateService, anchorService, documentContentsSearchService,
        resizeService, localStorageService, folderService, treeNavigationService, $q, configService, browserService) {

        var ignoreRichText = configService.getBool(HandbookConfiguration.LazyLoadRichText);

        var vm = this;
        var isFieldActive;
        var lastId;
        var urlParams = $location.url().split('/');

        vm.isEmbedUrl = false;

        if (urlParams != null && urlParams.length) {
            vm.isEmbedUrl = urlParams[1] == 'embed';
        }

        vm.currentData = {};
        vm.originalData = {};

        vm.enableExtendedFeedback = configService.getBool(HandbookConfiguration.EnableExtendedFeedback);
        

        vm.highlights = {
            highlightText: '',
            currentIndex: 0,
            totalFound: 0
        };
        vm.isShowMetadata = configService.getBool(HandbookConfiguration.MetadataEnabled);
        vm.isShowMetatagTab = configService.getBool(HandbookConfiguration.ShowMetatagTab);
        vm.simpleSubscription = configService.getBool(HandbookConfiguration.SimpleSubscription);
        vm.publishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);
        vm.backendIsDb4 = configService.getBool(HandbookConfiguration.BackendIsDb4);
        vm.showDocumentLinkToBackend = configService.getBool(HandbookConfiguration.ShowDocumentLinkToBackend);
        vm.enableDocumentExtention = configService.getBool(HandbookConfiguration.EnableDocumentExtention);
        vm.enableAgree = configService.getBool(HandbookConfiguration.EnabledAgree);
        vm.enableElementsIntegration = ElementsIntegrationConfiguration.ArchiveIntegrationMode != E.ArchiveIntegrationMode.None;

        vm.viewModeList =
            [
                { id: parseInt(E.documentTemplateViewMode.ProcessDependencies), name: globalResources.documentTemplateViewModeName.ProcessDependencies },
                { id: parseInt(E.documentTemplateViewMode.Normal), name: globalResources.documentTemplateViewModeName.Normal },
                { id: parseInt(E.documentTemplateViewMode.Process), name: globalResources.documentTemplateViewModeName.Process },
                { id: parseInt(E.documentTemplateViewMode.RelatedDocuments), name: globalResources.documentTemplateViewModeName.RelatedDocuments },
                { id: parseInt(E.documentTemplateViewMode.InvolvedChapters), name: globalResources.documentTemplateViewModeName.InvolvedChapters },
            ];

        vm.metadataList = [];
        vm.documentId = $stateParams.documentId;
        vm.addFavoriteRequest = handbookRequests.AddFavoriteDocument;
        vm.removeFavoriteRequest = handbookRequests.RemoveFavoriteDocument;
        vm.contentAnchorPrefix = prefix.contentAnchorPrefix;
        vm.processRelationTypes = E.ProcessRelationType;
        vm.showError = false;
        vm.isFullScreen = true;
        vm.heightdocumentcontentidentifier = 0;
        vm.FolderLinks = [];
        vm.menuFields = [];
        vm.urlDocument = window.location.origin + '/document/' + vm.documentId;
        vm.updateFields = updateFields;
        vm.goToDocumentFields = goToDocumentFields;
        vm.removeFromFavorite = removeFromFavorite;
        vm.searchAndHighlightText = searchAndHighlightText;
        vm.navForward = navForward;
        vm.navBackward = navBackward;
        vm.fullScreen = fullScreen;
        vm.selectViewModeChange = selectViewModeChange;
        vm.linkToDocumentManagement = linkToDocumentManagement;
        vm.isFloatTitle = $(window).height() > HandbookConfiguration.DocumentTitleScreenHeight ? true : false;
        vm.getNextSearchResultByEnter = getNextSearchResultByEnter;
        vm.compareDocument = compareDocument;
        vm.registDeviationWithDocument = registDeviationWithDocument;
        vm.hideCompareButton = false;
        vm.showContent = showContent;
        vm.shareFieldLink = shareFieldLink;
        vm.showSidebarFields = showSidebarFields;
        vm.printAgreeFile = printAgreeFile;
        vm.feedbackDocument = feedbackDocument;
        vm.goToDocumentInPublicHandbook = goToDocumentInPublicHandbook;
        vm.openAboutDocument = openAboutDocument;
        vm.addDocumetEmailSubscription = addDocumetEmailSubscription;
        vm.browserType = browserService.detectBrowserWindow();
        vm.BROWSER_TYPE = BrowserType;
        vm.documentCKVersion = CkVersion.CK4;
        vm.ckVersion = { 'CK4': CkVersion.CK4, 'CK5': CkVersion.CK5 };
        vm.isToggleSidebarFields = true;
        var isIE = detectIE();
        var cursorY;
        document.onmousemove = function (e) {
            cursorY = e.pageY;
        }
        vm.hideSidebarFields = hideSidebarFields;
        vm.agreeFiles = [];
        vm.extendDocumentsGridSetting = [];
        vm.documentNameHadExtended = '';
        vm.showExtendDocument = false;
        vm.totalExtendDocument = 0;
        vm.deviationUrl = HandbookConfiguration.DeviationUrl;
        vm.documentDeviationCategoryLink = HandbookConfiguration.DocumentDeviationCategoryLink;
        vm.enabledDeviation = configService.getBool(HandbookConfiguration.EnabledDeviation);
        vm.publicUrl = HandbookConfiguration.PublicURL;
        vm.isPublishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);
        vm.documentPublishTooltip = HandbookConfiguration.PublicURL && !vm.isPublishedVersion ? globalResources.GoToDocumentInPublicHandbook : globalResources.PublishedToTheInternet;
        vm.copyUserFriendlyPublishedUrlTooltip = globalResources.CopyUserFriendlyPublishedUrl;
        vm.copyUserFriendlyUrlTooltip = globalResources.CopyUserFriendlyUrl;
        vm.documentPublishUrl = HandbookConfiguration.PublicURL + `document/${vm.documentId}`;
        vm.addClass = 'copy-publish-url';
        vm.publishUrlImg = './Content/Images/shared-publish-internet.png'
        vm.documentViewOption = parseInt(HandbookConfiguration.DocumentViewOption);
        vm.searchDocumentInMobile = false;
        vm.toggleSearchInMobile = toggleSearchInMobile;
        vm.scrollDocumentContentToTop = scrollDocumentContentToTop;
        vm.setViewMode = setViewMode;
        vm.showContentanchor = showContentanchor;
        vm.clearAnchorActive = clearAnchorActive;
        vm.getHiddenFields = getHiddenFields;
        vm.fieldIds = [];

        vm.enabledProcessModule = configService.getBool(HandbookConfiguration.EnableProcess);

        vm.processClassificationTypes = E.processClassificationTypes;
        vm.goToProcessDetail = goToProcessDetail;

        vm.enableOpenDocumentOnline = configService.getBool(HandbookConfiguration.EnableOpenDocumentOnline);
        vm.openFileAttachOnline = openFileAttachOnline;
        vm.openFileDocumentOnline = openFileDocumentOnline;
        vm.IsHighlightExtended = false;

        vm.alerts = [];
        
        initialize();
     
        function initialize() {
            if (vm.enabledProcessModule) {
                vm.relatedToOrDocuments = resources.L.Document.relatedTo;
            }
            else {
                vm.relatedToOrDocuments = resources.L.Document.relatedDocuments;
            }

            if (vm.enableDocumentExtention) {
                builExtentDocumentsGridSetting();
            }

            if (angular.element('#handbook-nav:visible').length == 0) {
                documentService.showFullscreen();
                vm.isFullScreen = false;
            }
            fullScreenInit();

            processEmbedUrl();
            //check and resize the view
            resizeService.resizeView();
            //get document info from service
            if (!vm.isEmbedUrl) {
                var currentDocument = documentService.getDocuments();
                if (currentDocument && currentDocument.documentInformation) {
                    vm.isFavoriteNodeSelected = true;
                    buildDocumentObjectFromCurrentDocument(currentDocument);
                    $rootScope.title = globalResources.Handbook + " - " + currentDocument.documentInformation.documentName;

                    runServicesAfterInit();
                }
                else {
                    vm.getHiddenFields(vm.documentId);

                }
                folderService.getFolderByVirtualDocumentId($stateParams.documentId).then(function (response) {
                    vm.FolderLinks = response.data;
                });
            } else {
                vm.getHiddenFields(vm.documentId);
            }

            treeNavigationService.navigateToItemLocation(true);
            addScroll();
            if (vm.browserType == vm.BROWSER_TYPE.MOBILE) {
                handleScrollInMobile();
            }
        }

        $(window).on('resize', function () {
            vm.browserType = browserService.detectBrowserWindow();
        });

        function toggleSearchInMobile(){
            vm.searchDocumentInMobile = !vm.searchDocumentInMobile; 
        }

        function builExtentDocumentsGridSetting() {
            vm.extendDocumentsGridSetting.push({ id: 'documentIdDisplay', name: globalResources.CommonGridColumns.DocumentId, width: 5, coldefault: true });
            vm.extendDocumentsGridSetting.push({ id: 'documentNameDisplay', name: globalResources.Name, width: 30, coldefault: true });
            vm.extendDocumentsGridSetting.push({ id: 'pathDisplay', name: globalResources.Path, width: 35, coldefault: true });
            vm.extendDocumentsGridSetting.push({ id: 'strCreatedDateFirstVersion', name: globalResources.CreatedDate, width: 10, coldefault: true, type: COLUMN_DATA_TYPES.STRING_DATE});
            vm.extendDocumentsGridSetting.push({ id: 'responsible', name: globalResources.Responsible, width: 20, coldefault: true });
        }

        function loadExtendDocumentsTab() {
            $http.get('/api/Documents/GetExtendDocumentsByDocumentId', { params: { 'documentId': vm.documentId } })
                .success(function (data, status, headers, config) {
                    data = data || [];
                    vm.showExtendDocument = data.length > 0;
                    vm.totalExtendDocument = data.length;
                    vm.extendDocuments = data;
                    vm.extendDocumentNotification = '';

                    let linkTemp = "<a class='link-document-extend' href='{0}' target='_blank'>{1}</a>";
                    let linkDocTemp = "<a href='{0}' target='_blank'>{1}</a>";
                    let urlTemp = '/document/{0}';
                    let urlFolTemp = '/folder/{0}';
                    let count = 0;
                    for (var i = 0; i < vm.extendDocuments.length; i++) {
                        let document = vm.extendDocuments[i];
                        document.documentIdDisplay = String.format(linkDocTemp, String.format(urlTemp, document.documentId), document.documentId);
                        document.documentNameDisplay = String.format(linkDocTemp, String.format(urlTemp, document.documentId), document.documentName);
                        document.pathDisplay = String.format(linkDocTemp, String.format(urlFolTemp, document.folderId), document.path);
                        if (document.isDepartment) {
                            let link = document.documentNameDisplay;
                            vm.extendDocumentNotification += vm.extendDocumentNotification == '' ? link : ', ' + link;
                            document.documentNameDisplay = document.documentNameDisplay + `<span class="fa fa-info-circle extend-document-info-icon ml10" title="${globalResources.ExtensionLocatedInDepartmentFolder}"></span>`;
                            count = count + 1;
                        }
                    }

                    if (vm.extendDocumentNotification != '') {
                        let message = count > 1 ? globalResources.ExtendDocumentNotification : globalResources.ExtendDocumentNotificationForOnePerson;
                        vm.extendDocumentNotification = String.format(message, vm.extendDocumentNotification);
                        $timeout(function () {
                            tabStateService.adjustContentHeightPosition(tabStateType.documentTabState);
                        });
                        
                    }
                });
        }

        function getReadDocuments() {
            var storageObject = localStorageService.getItem(localStorageKeys.readDocuments);
            var readDocuments = [];
            if (storageObject != null) {
                readDocuments = JSON.parse(storageObject);
            }

            var existed = false, offset;
            for (var i = 0; i < readDocuments.length; i++) {
                if (readDocuments[i].id == vm.documentId) {
                    existed = true;
                    offset = i;
                    break;
                }
            }

            if (!existed) {
                readDocuments.push({ id: vm.documentId, approvedDate: vm.currentData.approvedDate });
            } else {
                readDocuments[offset].approvedDate = vm.currentData.approvedDate;
            }
            localStorageService.setItem(localStorageKeys.readDocuments, JSON.stringify(readDocuments));
        }



        function getDocument() {
            if (vm.isShowMetadata && vm.isShowMetatagTab) {
                getMetadataTab();
            }

            var params = {
                params: {
                    'documentId': $stateParams.documentId,
                    'ignoreRichText': ignoreRichText,
                    'hasExtention': vm.enableDocumentExtention,
                    showLoading: true
                }
            };

            vm.currentDataPromise = $http.get(handbookRequests.GetDocumentInformationRequest, params)
                .then(function (result, status, headers, config) {
                    if (result != null) {
                        if (result.data.hidden) {
                            showMessageError(globalResources.NoAccessDocument, status);
                            return;
                        }
                        vm.currentData = result.data;
                        adjustHeightDocument();
                        var viewMode = vm.currentData.viewMode;
                        var hash = window.location.hash;

                        if (vm.enableDocumentExtention && DOCUMENT_EXTENDABLE_TYPES.PARENT == vm.currentData.extendable) {
                            loadExtendDocumentsTab();
                        }

                        if (vm.enableDocumentExtention && DOCUMENT_EXTENDABLE_TYPES.CHILD == vm.currentData.extendable) {
                            let href = '/document/' + vm.currentData.documentIdHadExtended;
                            let extendDocumentUrl = String.format("<a class='link-document-extenable' href='{0}' target='_blank'>{1}</a>", href, vm.currentData.documentNameHadExtended);
                            vm.documentNameHadExtended = globalResources.DocumentIsAnExtensionOf + extendDocumentUrl;
                        }

                        if (hash) {
                            vm.currentData.viewMode = 1;

                        }
                        vm.currentData.fieldContents = vm.currentData.fieldContents.filter(function (x) {
                            return x.isVisible;
                        });
                        vm.documentCKVersion = vm.currentData.isNewCKVersion;
                        vm.isFavoriteNodeSelected = true;
                        createTooltipsRelatedDocument(result.data);
                        if (vm.currentData.description) {
                            vm.currentData.description = $sce.trustAsHtml(vm.currentData.description.replace(new RegExp(String.fromCharCode(13) + String.fromCharCode(10), 'g'), '<br/>'));
                        }
                        vm.currentData.nodeType = convertToNodeType(vm.currentData.type);
                        if (vm.currentData.fieldContents != null) {
                            var indexTemp = 0;

                            var richTextRequests = [];
                            vm.currentData.fieldContents.forEach((field) => {
                                var fieldContent = vm.fieldIds.find((x) => x.fieldId === field.fieldId);

                                if (fieldContent) {
                                    field.isHiddenContent = true;
                                } else {
                                    field.isHiddenContent = false;
                                }
                            });
                            var isDocumentJustCreated = vm.currentData.fieldContents.some(x => x.fieldContentId == 0);
                            if (DOCUMENT_EXTENDABLE_TYPES.CHILD == vm.currentData.extendable && isDocumentJustCreated) {
                                var params = {
                                    params: {
                                        'documentId': vm.currentData.documentIdHadExtended,
                                        'ignoreRichText': ignoreRichText,
                                        'hasExtention': vm.enableDocumentExtention,
                                        showLoading: true,
                                    }
                                };
                                $http.get(handbookRequests.GetDocumentInformationRequest, params)
                                    .then(function (response, status, headers, config) {
                                        response.data.fieldContents = response.data.fieldContents.filter(x => x.isVisible);
                                        richTextRequests = [];
                                        response.data.fieldContents.forEach(function (fieldContent) {
                                            if (ignoreRichText && fieldContent.fieldType == E.DocumentFieldTypes.RichText && fieldContent.fieldContentId) {
                                                var params = {
                                                    params: {
                                                        id: fieldContent.fieldContentId,
                                                        documentId: vm.currentData.documentIdHadExtended,
                                                        ignoreLoading: true,
                                                        hasExtention: vm.enableDocumentExtention,
                                                        isHiddenContent: fieldContent.isHiddenContent
                                                    }
                                                }
                                                var getRichText = $http.get('/api/documents/getRichTextViewDocument', params).then(function (response) {
                                                    if (response.data && response.data.content) {
                                                        var childFieldContent = vm.currentData.fieldContents.find(x => x.fieldId == fieldContent.fieldId);
                                                        buildContentAndAnchorFields(childFieldContent, response);
                                                    }
                                                });
                                                richTextRequests.push(getRichText);
                                            }
                                        });
                                    });
                            } else {
                                vm.currentData.fieldContents.forEach(function (fieldContent) {
                                    if (fieldContent.description) {
                                        fieldContent.description = $sce.trustAsHtml(fieldContent.description);
                                    }
                                    vm.menuFields.push("Id" + fieldContent.fieldId);
                                    if (ignoreRichText && fieldContent.fieldType == E.DocumentFieldTypes.RichText && fieldContent.fieldContentId) {
                                        if (vm.currentData.isHighlightExtended) {
                                            vm.IsHighlightExtended = true;
                                        }
                                        var params = {
                                            params: {
                                                id: fieldContent.fieldContentId,
                                                documentId: vm.documentId,
                                                hasExtention: vm.enableDocumentExtention,
                                                isHiddenContent: fieldContent.isHiddenContent, 
                                                isHighlightExtended: vm.IsHighlightExtended
                                            }
                                        }
                                        //var params = {
                                        //    params: {
                                        //        id: fieldContent.fieldContentId,
                                        //        documentId: vm.currentData.documentIdHadExtended,
                                        //        ignoreLoading: true,
                                        //        hasExtention: vm.enableDocumentExtention,
                                        //        isHiddenContent: fieldContent.isHiddenContent
                                        //    }
                                        //}

                                        var richtextRequest = $http.get('/api/documents/getRichTextViewDocument', params).then(function (response) {
                                            if (response.data && response.data.content) {
                                                buildContentAndAnchorFields(fieldContent, response);
                                            }
                                        });

                                        richTextRequests.push(richtextRequest);

                                    } else {
                                        if (fieldContent.content) {
                                            fieldContent.content = documentService.changeUrlBackendToFrontend(window.location.origin, fieldContent.content, false, vm.deviationUrl);
                                            fieldContent.content = $sce.trustAsHtml(`${fieldContent.content} `);
                                        }
                                    }

                                    fieldContent.indexShow = indexTemp;
                                    indexTemp = indexTemp + 1;
                                });
                            }
                            

                            if (ignoreRichText) {
                                $q.all(richTextRequests).then(function () {
                                    vm.currentData.fieldContents = vm.currentData.fieldContents.filter(x => x.content != "&nbsp;"); // checkout fieldcontent is empty
                                    angular.copy(vm.currentData, vm.originalData);
                                    $timeout(function () {
                                        runServicesAfterInit();
                                        if (hash) {
                                            moveToDefaultField(hash);
                                        } else if (viewMode == 1) openDocumentFields(result.data)
                                    });


                                });
                            }
                            if (vm.currentData.type == 2) {
                                vm.menuFields.unshift("IdLink");
                            }
                            if (vm.currentData.type == 1) {
                                vm.menuFields.unshift("IdFile");

                            }

                            var agree = vm.currentData.agree;
                            if (agree && agree.id && agree.id != 0) {
                                if (agree.searchHistoryId) {
                                    vm.agreeFiles.push({
                                        id: agree.searchHistoryId,
                                        extensionName: agree.searchHistoryFileName.split('.').pop().toUpperCase(),
                                        name: agree.searchHistoryFileName,
                                        fileTypeName: globalResources.SearchHistory,
                                        fileType: 1
                                    });
                                }
                                if (agree.abstractListId) {
                                    vm.agreeFiles.push({
                                        id: agree.abstractListId,
                                        extensionName: agree.abstractListFileName.split('.').pop().toUpperCase(),
                                        name: agree.abstractListFileName,
                                        fileTypeName: globalResources.AbstractList,
                                        fileType: 1
                                    });
                                }
                                if (agree.implementationPlanId) {
                                    vm.agreeFiles.push({
                                        id: agree.implementationPlanId,
                                        extensionName: agree.implementationPlanFileName.split('.').pop().toUpperCase(),
                                        name: agree.implementationPlanFileName,
                                        fileTypeName: globalResources.ImplementationPlan,
                                        fileType: 1
                                    });
                                }
                                if (vm.currentData.knowledgeTypeId == KnowledgeType.allAgreeRequirements) {
                                    vm.agreeFiles.push({
                                        id: vm.currentData.entityId,
                                        extensionName: 'pdf',
                                        name: globalResources.PicoForm,
                                        fileTypeName: globalResources.PicoForm,
                                        fileType: 2
                                    });
                                }
                                if (vm.currentData.knowledgeTypeId == KnowledgeType.allAgreeRequirements
                                    || vm.currentData.knowledgeTypeId == KnowledgeType.shortVersionOfAgreeRequirements) {
                                    vm.agreeFiles.push({
                                        id: vm.currentData.entityId,
                                        extensionName: 'pdf',
                                        name: globalResources.AgreeMethodReport,
                                        fileTypeName: globalResources.AgreeMethodReport,
                                        fileType: 3
                                    });
                                }
                            }

                            if (vm.agreeFiles.length) {
                                vm.menuFields.push("IdAgreeFiles");
                            }

                            if (vm.currentData.relatedAttachments.length) {
                                vm.menuFields.push("Idattachment");
                            }

                            if (vm.currentData.relatedDocuments.length) {
                                vm.menuFields.push("IdrelatedDocument");
                            }
                            vm.updateFields();
                        }

                        if (vm.isShowMetadata && vm.isShowMetatagTab) {
                            vm.currentData.metadatas = angular.copy(vm.metadataList);
                            formatMetadata();
                        }
                        vm.showDocumentLinkToBackend = vm.showDocumentLinkToBackend &&
                            (vm.currentData.hasEditPermission || vm.currentData.hasApprovalPermission);

                        if (!ignoreRichText || !vm.currentData.fieldContents) {
                            runServicesAfterInit();
                        }

                        angular.copy(vm.currentData, vm.originalData);

                        setTimeout(function () { documentService.stickyTitle(); }, 0);
                        setIconForDocument(vm.currentData);
                        getReadDocuments();
                        sendDocumentOpenedEvent();
                        executeDocumentTypeIfNeeded();
                        vm.currentData.urlLink = vm.currentData.url;
                        if (vm.currentData.url != null && vm.currentData.url.length > 3) {
                            if (vm.currentData.url.substring(0, 3) == 'www') {
                                vm.currentData.urlLink = 'http://' + vm.currentData.url;
                            }
                        }

                        documentService.setDocuments(null); // clear service                     
                        $rootScope.title = globalResources.Handbook + " - " + result.data.documentName;

                        vm.isCompare = configService.getBool(HandbookConfiguration.EnableCompare) && vm.currentData.version > 0;
                        if (!vm.isCompare && vm.currentData.extendable == DOCUMENT_EXTENDABLE_TYPES.CHILD) {
                            documentService.checkParentExtensionHasToCompare(vm.currentData.documentId)
                                .then(function (data) {
                                    if (data) {
                                        vm.isCompare = data;
                                    }
                                });
                        }

                        if (vm.currentData.type == E.documentTypes.LinkDocument || vm.currentData.type == E.documentTypes.FileDocument) {
                            vm.hideCompareButton = true;
                        }
                        return vm.currentData;
                    } else {
                        showMessageError(globalResources.NoAccessDocument, status);
                    }
                }).catch(function (result, status, headers, config) {
                    showMessageError(result.data, result.status);
                });
        }

        function buildContentAndAnchorFields(childFieldContent, response) {
            childFieldContent.content = documentService.changeUrlBackendToFrontend(window.location.origin, response.data.content, false, vm.deviationUrl);
            childFieldContent.content = $sce.trustAsHtml(`${childFieldContent.content} `);
            childFieldContent.isVisible = true;
            childFieldContent.fieldsAnchor = [];
            var aElement = document.createElement('div');
            aElement.innerHTML = response.data.content;
            var aTags = aElement.getElementsByTagName('a');
            if (aTags) {
                for (var i = 0; i < aTags.length; i++) {
                    if (aTags[i].text.trim().length) {
                        var itemAnchor = {
                            value: aTags[i].text,
                            id: aTags[i].name,
                            name: aTags[i].id
                        };
                        childFieldContent.fieldsAnchor.push(itemAnchor);
                    }

                }
            };
        }

        function getHiddenFields(documentId, result) {
            vm.fieldIds = [];
            //vm.alerts.unshift({ type: 'danger', message: "aaaaaa"});
            $http.get(handbookRequests.GetHiddenFieldsRequest, { params: { 'documentId': vm.documentId } })
                .success(function (data) {
                    vm.fieldIds = data;
                    getDocument();
                })
                .error(function (data, status, headers, config) {
                    vm.alerts.unshift({
                        type: 'danger', message: resources.L.Common.dontHaveActionPermission });
                });
        }

        function setIconForDocument(data) {
            data = data == null ? vm.currentData : data;
            var icon = '';
            switch (data.levelType.toString()) {
                case E.HandbookLevelTypes.Enterprise:
                    icon = paths.DocumentLevelTypeEnterprise;
                    break;
                case E.HandbookLevelTypes.Regional:
                    icon = paths.DocumentLevelTypeRegional;
                    break;
                case E.HandbookLevelTypes.Local:
                    icon = paths.DocumentLevelTypeLocal;
                    break;
                default:
                    icon = paths.DocumentLevelTypeEnterprise;
                    break;
            }
            data.docIcon = icon;
        }

        function showMessageError(message, status) {
            if (!status || status.toString() == '600') {
                vm.errorMessage = globalResources.RequiredPermissionsToReadDocument;
            } else if (status.toString() == '632') {
                vm.errorMessage = globalResources.DocumentDoNotExistOrIsArchived;
            } else if (status.toString() == '633') {
                vm.errorMessage = globalResources.DocumentDoNotExistOrIsArchivedOrNotPublished;
                vm.showDocumentLinkToBackendWhenError = true;
            } else {
                vm.errorMessage = message;
            }
            vm.showError = true;
            vm.isFavoriteNodeSelected = favoriteService.getFavoriteNodeState().isFavorited;
            vm.currentData.documentId = vm.documentId;
            vm.currentData.isFavorite = vm.isFavoriteNodeSelected;

            runErrorServicesAfterInit();
        }

        function getMetadataTab() {
            $http.get(handbookRequests.GetDocumentMetadataRequest, { params: { 'documentId': $stateParams.documentId } })
                .then(function (result) {
                    vm.metadataList = result.data;
                });
        }

        function formatMetadata() {
            if (vm.isShowMetadata && vm.currentData.metadatas && vm.currentData.metadatas.length && vm.isShowMetatagTab) {
                vm.currentData.metadatas.forEach(function (item) {
                    item.nameDisplay = $sce.trustAsHtml(item.registerName + ' - ' + item.registerItemName + ' - ' + item.registerValue);
                });
            }
        }

        function rebindCurrentDocument(currentDocument) {
            vm.isFavoriteNodeSelected = true;
            vm.currentData = angular.copy(currentDocument.documentInformation);
            setIconForDocument(vm.currentData);
            $rootScope.title = globalResources.Handbook + " - " + vm.currentData.documentName;

            if (vm.currentData.description) {
                vm.currentData.description = $sce.trustAsHtml(vm.currentData.description.toString());
            }
            vm.currentData.fieldContents.forEach(function (fieldContent) {
                if (fieldContent.content) {
                    fieldContent.content = $sce.trustAsHtml(fieldContent.content + ' ');
                }
                if (fieldContent.description) {
                    fieldContent.description = $sce.trustAsHtml(fieldContent.description.toString());
                }
            });

            if (vm.isShowMetadata && vm.isShowMetatagTab) {
                formatMetadata();
            }
            angular.copy(vm.currentData, vm.originalData);
            vm.documentId = vm.currentData.documentId;

            runServicesAfterInit();
            setTimeout(function () { documentService.stickyTitle(); }, 0);
            var preview = $location.url().indexOf('preview');
            if (configService.getBool(HandbookConfiguration.ViewDocumentFieldDirectly) && preview == -1) {
                openDocumentFields();
            }
        }

        function updateFields() {
            if (vm.currentData.relatedAttachments && vm.currentData.relatedAttachments.length) {
                vm.currentData.relatedAttachments.forEach(function (x) {
                    x.itemId = x.extraId ? x.extraId : x.itemId;
                });
            }
            var relatedDocumentAll = angular.copy(vm.currentData.relatedDocuments);
            var relatedAttachmentAll = angular.copy(vm.currentData.relatedAttachments);
            var fieldContentsProcess = [];
            var fieldContentsNonProcess = [];
            var relatedProcessAll = angular.copy(vm.currentData.relatedProcess);

            vm.currentData.isShowTopBoxContent = false;

            for (var i = 0; i < vm.currentData.fieldContents.length; i++) {
                var fieldContent = vm.currentData.fieldContents[i];

                if (checkShowFieldName(fieldContent)) {
                    vm.currentData.isShowTopBoxContent = true;
                    if (fieldContent.relatedAttachments && fieldContent.relatedAttachments.length) {
                        fieldContent.relatedAttachments.forEach(function (x) {
                            x.itemId = x.extraId ? x.extraId : x.itemId;
                        });
                    }

                    if (fieldContent.isProcess) {
                        fieldContentsProcess.push(fieldContent);
                    }
                    else {
                        fieldContentsNonProcess.push(fieldContent);
                    }
                }

                var relatedDocuments = fieldContent.relatedDocuments;
                relatedDocumentAll = relatedDocumentAll.concat(relatedDocuments);
                relatedProcessAll = relatedProcessAll.concat(fieldContent.relatedProcess);

                var relatedAttachments = fieldContent.relatedAttachments;
                relatedAttachmentAll = relatedAttachmentAll.concat(relatedAttachments);

                var relatedImageGroups = groupBy(fieldContent.images, function (item) {
                    return [item.verticalAlign];
                });
                var relatedBottomImages = [];
                var relatedTopImages = [];
                relatedImageGroups.forEach(function (item) {
                    if (item.key == parseInt(E.VerticalAlign.Top)) {
                        relatedTopImages = relatedTopImages.concat(item.value.data);
                    } else {
                        if (item.key == parseInt(E.VerticalAlign.Bottom)) {
                            relatedBottomImages = relatedBottomImages.concat(item.value.data);
                        }
                    }
                });
                fieldContent.relatedTopImages = relatedTopImages;
                fieldContent.relatedBottomImages = relatedBottomImages;
            }

            if (vm.currentData.isProcess) {
                vm.currentData.relatedDocumentAll = relatedDocumentAll;
                vm.currentData.relatedAttachmentAll = relatedAttachmentAll;

                vm.currentData.fieldContentsProcess = fieldContentsProcess;
                vm.currentData.fieldContentsNonProcess = fieldContentsNonProcess;

                vm.currentData.relatedProcessAll = relatedProcessAll;

                var relatedDocumentGroups = groupBy(relatedDocumentAll, function (item) {
                    return [item.folderId];
                });

                vm.currentData.relatedDocumentGroups = [];
                relatedDocumentGroups.forEach(function (item) {
                    var relatedDocumentGroup = {};
                    relatedDocumentGroup.id = item.key;
                    relatedDocumentGroup.name = item.value.data[0].folderName;
                    relatedDocumentGroup.relatedDocuments = item.value.data;
                    vm.currentData.relatedDocumentGroups.push(relatedDocumentGroup);
                });

                var relatedProcessGroups = groupBy(relatedProcessAll, function (item) {
                    return [item.processAreaId];
                });
                vm.currentData.relatedProcessGroups = [];
                relatedProcessGroups.forEach(function (item) {
                    var relatedProcessGroup = {};
                    relatedProcessGroup.id = item.key;
                    relatedProcessGroup.name = item.value.data[0].processAreaName;
                    relatedProcessGroup.relatedProcesses = item.value.data;
                    vm.currentData.relatedProcessGroups.push(relatedProcessGroup);
                });

                relatedDocumentForDependencies(relatedDocumentAll);
                relatedAttachmentForDependencies(relatedAttachmentAll);
                attachRelatedItemsFieldsForDependencies();
            }
        }

        $scope.$on(broadcastType.favoriteUpdate, function (e, target) {
            if (vm.originalData) {
                vm.originalData.isFavorite = target;
            }
            if (vm.currentData) {
                vm.currentData.isFavorite = target;
            }
        });

        function goToDocumentFields(fieldId, hash) {
            isFieldActive = false;
            clearActive();
            vm.currentData.viewMode = 1;
            setTimeout(function () {
                var field = vm.currentData.fieldContents.find(function (x) {
                    return x.fieldId == fieldId;
                });
                if (field) showContent(fieldId, field);
                runServicesAfterInit();
            }, 1000)
            addScroll();

        }

        function copyFormatted(html) {
            // Create an iframe (isolated container) for the HTML
            var container = document.createElement('div');
            container.innerHTML = html;

            // Hide element
            container.style.position = 'fixed';
            container.style.pointerEvents = 'none';
            container.style.opacity = 0;

            // Mount the iframe to the DOM to make `contentWindow` available
            document.body.appendChild(container);

            // Copy to clipboard
            window.getSelection().removeAllRanges();

            var range = document.createRange();
            range.selectNode(container);
            window.getSelection().addRange(range);

            //copy selected dom
            document.execCommand('copy');

            // Remove the iframe
            document.body.removeChild(container);
        }

        function shareFieldLink(fieldId, fieldName) {
            if (vm.fieldShare != fieldId) {
                vm.fieldShare = fieldId;
                angular.element('#fieldShare' + fieldId).addClass('opacity-0-5');
                var link = window.location.href.split('#')[0] + '#p' + fieldId;
                var shareLink = '<a href="' + link + '" target="_blank" style="font-size: 16px; text-decoration: underline; color: blue">' + vm.currentData.documentName + ' - ' + fieldName + '</a>';
                $('#html-container').text(shareLink);
                var htmlEditor = CodeMirror.fromTextArea(document.getElementById('html-container'), {
                    mode: 'text/html'
                });
                var cm = $('.CodeMirror')[0].CodeMirror;
                $(cm.getWrapperElement()).hide();
                copyFormatted(htmlEditor.getValue());
                $timeout(function () {
                    vm.fieldShare = 0;
                    angular.element('#fieldShare' + fieldId).removeClass('opacity-0-5');
                }, 5000, false);
            }
        }

        function openDocumentFields(data) {
            for (var i = 0; i < data.fieldContents.length; i++) {
                var fieldContent = data.fieldContents[i];
                if (fieldContent.showOnPDA) {
                    showContent(fieldContent.fieldId, fieldContent);
                    return;
                }
            };
            //in case there is no PDA of documentType
            if (data.defaultField != null) {
                //get all visible field (field has contents)
                var allVisibleField = $filter('filter')(data.fieldContents, { isVisible: true }, true);
                if (allVisibleField.length != 0) {
                    //get default field
                    var field = $filter('filter')(allVisibleField, { fieldId: data.defaultField }, true);
                    var fieldId = allVisibleField[0].fieldId;
                    if (field.length) {
                        fieldId = data.defaultField;
                        showContent(data.defaultField, field[0]);
                    } else if (data.fieldContents[0]) showContent(data.fieldContents[0].fieldId, data.fieldContents[0]);
                }
            } else if (data.fieldContents[0]) showContent(data.fieldContents[0].fieldId, data.fieldContents[0]);

        }

        function scrollAffectFieldSelected() {
            var
                topMenuDocument = $("#document-top-menu-identifier"),
                topMenuDocumentHeight = topMenuDocument.outerHeight(),
                idCurrent = '';

            var mousePosition = getMousePosition();

            if (typeof mousePosition == 'undefined') {
                return;
            }
            var d;
            for (var i = 0; i < vm.menuFields.length; i++) {
                d = i;
                var menu = "#" + vm.menuFields[i];
                var top = $(menu).offset().top;
                if (mousePosition < top) {
                    idCurrent = i == 0 ? vm.menuFields[0] : vm.menuFields[i - 1];
                    break;
                }
            }
            if (idCurrent == '') {
                idCurrent = vm.menuFields[d];
            }


            if ((lastId !== idCurrent) && (idCurrent != '')) {
                lastId = idCurrent;
                angular.forEach(vm.currentData.fieldContents, function (fieldContent) {
                    fieldContent.activeField = '';
                });
                clearActive();
                switch (lastId) {
                    case 'IdLink':
                        $scope.$apply(function () { vm.activeLink = true; });
                    case 'IdFile':
                        $scope.$apply(function () { vm.activeFile = true; });
                    case 'Idattachment':
                        $scope.$apply(function () { vm.activeAttachments = true; });
                        break;
                    case 'IdrelatedDocument':
                        $scope.$apply(function () { vm.activeRelatedDocuments = true; });
                        break;
                    case 'IdAgreeFiles':
                        $scope.$apply(function () { vm.activeAgreeFiles = true; });
                        break;
                    default:
                        var fieldId = lastId.substring(2);
                        for (var i = 0; i < vm.currentData.fieldContents.length; i++) {
                            if (vm.currentData.fieldContents[i].fieldId == parseInt(fieldId)) {
                                $scope.$apply(function () {
                                    vm.currentData.fieldContents[i].activeField = 'active';
                                });
                                break;
                            }
                        }
                }
            }
        }

        function addScroll() {
            setTimeout(function () {
                var content = $(".document-detail");
                if (content) {
                    content.scroll(function () {
                        if (!isFieldActive) {
                            scrollAffectFieldSelected();
                        }
                    });
                }
            })
        }

        function setStickyTitle() {
            setTimeout(function () { stickyTitle(); }, 0);
        }

        function stickyTitle(height) {
            var title = document.querySelector('#documentTitle');
            var titlePosition = title.getBoundingClientRect();
            var content = document.querySelector('#document-content-identifier');
            if (!content) {
                return;
            }

            var contentPosition = content.getBoundingClientRect();
            var placeholder = $("#placeholderTitleId")
            if (placeholder.length > 0) {
                placeholder.remove();
            }
            placeholder = document.createElement('div');
            placeholder.id = "placeholderTitleId";
            placeholder.style.height = titlePosition.height + 'px';
            var isAdded = false;
            var heightToFloat = 0, currentPosition = 0;
            heightToFloat = contentPosition.top + 50;
            var heightScroll = height ? height : $('#document-content-identifier').height();

            if ($(window).height() > HandbookConfiguration.DocumentTitleScreenHeight) {
                removeStickyTitle();
                $('#document-content-identifier').scroll(function () {
                    var scrollTop = $('#document-content-identifier').scrollTop();
                    var isfullScreen = $('#document-content-identifier').hasClass('fullScreen-height');
                    currentPosition = isfullScreen ? scrollTop : contentPosition.top + scrollTop;
                    if (currentPosition >= heightToFloat && !isAdded) {
                        title.classList.add('sticky');
                        document.querySelector('#document-content-identifier').classList.add('scrolling');

                        title.parentNode.insertBefore(placeholder, title);
                        isAdded = true;
                        var contentWidth = $('#document-content-identifier').width() + 10;
                        if (!isfullScreen) {
                            $('#documentTitle').css('top', contentPosition.top);
                            $('#documentTitle').css('width', contentWidth);
                            $('#documentTitle').css('background-color', 'white');
                        } else {
                            $('#documentTitle').css('width', contentWidth);
                            $('#documentTitle').css('background-color', 'white');
                        }
                        heightScroll = !isfullScreen ? heightScroll : screen.availHeight - 100;
                        $('#document-content-identifier').css('margin-top', '85px');
                        $('#document-content-identifier').css('height', heightScroll - 85);
                    } else if (currentPosition < heightToFloat && isAdded) {
                        title.classList.remove('sticky');
                        document.querySelector('#document-content-identifier').classList.remove('scrolling');

                        $('#documentTitle').css('top', '');
                        $('#documentTitle').css('width', '');
                        $('#documentTitle').css('background-color', '');
                        $('#documentTitle').css('margin-left', '');
                        title.parentNode.removeChild(placeholder);
                        isAdded = false;
                        $('#document-content-identifier').css('margin-top', '0px');
                        $('#document-content-identifier').css('height', heightScroll);
                    } else {
                        //$('#document-content-identifier').css('height', heightScroll);
                    }
                    if (!isFieldActive) {
                        scrollAffectFieldSelected();
                    }

                });
            }
            else {
                $('#document-content-identifier').scroll(function () {
                    var isfullScreen = $('#document-content-identifier').hasClass('fullScreen-height');
                    currentPosition = isfullScreen ? $('#document-content-identifier').scrollTop() : contentPosition.top + $('#document-content-identifier').scrollTop();
                    if (!isFieldActive) {
                        scrollAffectFieldSelected();
                    }
                });
            }
        }

        function runInitforIE(height) {
            if ($(window).height() > HandbookConfiguration.DocumentTitleScreenHeight) {
                var title = document.querySelector('#documentTitle');
                var titlePosition = title.getBoundingClientRect();
                var content = document.querySelector('#document-content-identifier');
                var contentPosition = content.getBoundingClientRect();
                var placeholder = $("#placeholderTitleId")
                if (placeholder.length > 0) {
                    placeholder.remove();
                }
                placeholder = document.createElement('div');
                placeholder.id = "placeholderTitleId";
                var heightToFloat = 0, currentPosition = 0;
                heightToFloat = contentPosition.top + 50;
                var heightScroll = height ? height : $('#document-content-identifier').height();
                var scrollTop = $('#document-content-identifier').scrollTop();
                var isfullScreen = $('#document-content-identifier').hasClass('fullScreen-height');
                currentPosition = isfullScreen ? scrollTop : contentPosition.top + scrollTop;
                if (currentPosition >= heightToFloat) {
                    title.classList.add('sticky');
                    document.querySelector('#document-content-identifier').classList.add('scrolling');

                    title.parentNode.insertBefore(placeholder, title);
                    var contentWidth = $('#document-content-identifier').width() + 10;
                    if (!isfullScreen) {
                        $('#documentTitle').css('top', contentPosition.top);
                        $('#documentTitle').css('width', contentWidth);
                        $('#documentTitle').css('background-color', 'white');
                    } else {
                        $('#documentTitle').css('width', contentWidth);
                        $('#documentTitle').css('background-color', 'white');
                    }
                    heightScroll = !isfullScreen ? heightScroll : screen.availHeight - 100;
                    $('#document-content-identifier').css('margin-top', '90px');
                    $('#document-content-identifier').css('height', heightScroll - 90);
                }
            }
        }

        function redirectGoToDocumentFields(fieldId) {
            if (user.fromState && user.fromState.name == 'documentfields'
                && user.fromParams && user.fromParams.documentId == vm.documentId) {
                window.history.go(-1);
            } else {
                var hash = window.location.hash;
                goToDocumentFields(fieldId, hash);
            }
        }

        $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {
            user.fromState = fromState;
            user.fromParams = fromParams;
        });

        function removeFromFavorite() {
            var requestUrl = vm.removeFavoriteRequest + '/' + vm.documentId;
            $http.post(requestUrl)
                .then(function () {
                    var target = {
                        data: {
                            id: vm.documentId,
                            isDocument: true
                        },
                        requestType: requestType.removeRequest
                    };
                    broadcastService(broadcastType.favoriteTarget, target);
                });
        }

        function searchAndHighlightText() {
            highlightTextInContent();
            documentContentsSearchService.searchAndHighlightText(vm.highlights);
        }

        function navForward() {
            documentContentsSearchService.navForward(vm.highlights);
        }

        function navBackward() {
            documentContentsSearchService.navBackward(vm.highlights);
        }

        function checkShowFieldName(fieldContent) {
            if (fieldContent.fieldName != '' && fieldContent.fieldName != undefined && fieldContent.isVisible && !fieldContent.isHideByBooklet) {
                return true;
            }
            return false;
        }

        function convertToNodeType(documentType) {
            switch (documentType.toString()) {
                case E.documentTypes.Document:
                    return E.nodeTypes.Document;
                case E.documentTypes.LinkDocument:
                    return E.nodeTypes.LinkDocument;
                case E.documentTypes.FileDocument:
                    return E.nodeTypes.FileDocument;
                case E.documentTypes.ShortcutDocument:
                    return E.nodeTypes.ShortcutDocument;
            }
        }

        function selectViewModeChange() {        
            history.replaceState("", document.title, window.location.pathname
                + window.location.search);
            setTimeout(function () {
                if (vm.currentData.fieldContents[0]);
                showContent(vm.currentData.fieldContents[0].fieldId, vm.currentData.fieldContents[0]);
                runServicesAfterInit();

                // change height content of document
                var mainBody = angular.element(".main-container_body").height();
                var docContent = angular.element("#content-tab").height();

                angular.element('#document-content-identifier').css({
                    height: (mainBody - docContent - 122)
                });

            }, 500)
            addScroll();
        }

        function runErrorServicesAfterInit() {
            tabStateService.closeOpenedTabIfNoPrivilege(tabStateType.documentTabState);
        }

        function scrollToAnchorIfExists() {
            var hash = $location.hash();
            if (hash != '') {
                $anchorScroll();
            }
        }

        function updateLocalAnchors() {
            var domContent = angular.element('div#document-content-identifier');
            anchorService.updateLocalAnchors(domContent);
        }

        function highlightTextInContent() {
            if (vm.currentData.fieldContents != undefined) {
                var viewMode = angular.copy(vm.currentData.viewMode);
                angular.copy(vm.originalData, vm.currentData);
                vm.currentData.viewMode = viewMode;
                vm.currentData.fieldContents.forEach(function (fieldContent) {
                    fieldContent.content = documentContentsSearchService.searchAndHighlight(fieldContent.content, vm.highlights.highlightText);
                    fieldContent.description = $sce.trustAsHtml(fieldContent.description.toString());
                });
            }
        }

        function relatedDocumentForDependencies(relatedDocumentAll) {
            var relatedDocumentGroups = groupBy(relatedDocumentAll, function (item) {
                return [item.processRelationType];
            });
            var relatedDocumentManagements = [];
            var relatedDocumentResources = [];
            relatedDocumentGroups.forEach(function (item) {
                if (item.key == parseInt(vm.processRelationTypes.Management)) {
                    relatedDocumentManagements = relatedDocumentManagements.concat(item.value.data);
                } else {
                    if (item.key == parseInt(vm.processRelationTypes.Resources)) {
                        relatedDocumentResources = relatedDocumentResources.concat(item.value.data);
                    }
                }
            });

            vm.currentData.relatedDocumentManagement = relatedDocumentManagements;
            vm.currentData.relatedDocumentResources = relatedDocumentResources;
        }

        function relatedAttachmentForDependencies(relatedAttachmentAll) {
            var relatedAttachmentGroups = groupBy(relatedAttachmentAll, function (item) {
                return [item.processRelationType];
            });

            var relatedAttachmentManagements = [];
            var relatedAttachmentResources = [];
            relatedAttachmentGroups.forEach(function (item) {
                if (item.key == parseInt(vm.processRelationTypes.Management)) {
                    relatedAttachmentManagements = relatedAttachmentManagements.concat(item.value.data);
                } else {
                    if (item.key == parseInt(vm.processRelationTypes.Resources)) {
                        relatedAttachmentResources = relatedAttachmentResources.concat(item.value.data);
                    }
                }
            });
            vm.currentData.relatedAttachmentManagement = relatedAttachmentManagements;
            vm.currentData.relatedAttachmentResources = relatedAttachmentResources;
        }

        function attachRelatedItemsFieldsForDependencies() {
            vm.currentData.fieldContentsProcess.forEach(function (field) {
                var relatedDocumetFieldGroups = groupBy(field.relatedDocuments, function (item) {
                    return [item.processRelationType];
                });
                var relatedDocumentInputValues = [];
                var relatedDocumentOutputValue = [];
                relatedDocumetFieldGroups.forEach(function (item) {
                    if (item.key == parseInt(vm.processRelationTypes.InputOrInputValues)) {
                        relatedDocumentInputValues = relatedDocumentInputValues.concat(item.value.data);
                    } else {
                        if (item.key == parseInt(vm.processRelationTypes.OutputOrOutputValues)) {
                            relatedDocumentOutputValue = relatedDocumentOutputValue.concat(item.value.data);
                        }
                    }
                });
                field.relatedDocumentInputValues = relatedDocumentInputValues;
                field.relatedDocumentOutputValue = relatedDocumentOutputValue;

                var relatedAttachmentFieldGroups = groupBy(field.relatedAttachments, function (item) {
                    return [item.processRelationType];
                });
                var relatedAttachmentInputValues = [];
                var relatedAttachmentOutputValue = [];
                relatedAttachmentFieldGroups.forEach(function (item) {
                    if (item.key == parseInt(vm.processRelationTypes.InputOrInputValues)) {
                        relatedAttachmentInputValues = relatedAttachmentInputValues.concat(item.value.data);
                    } else {
                        if (item.key == parseInt(vm.processRelationTypes.OutputOrOutputValues)) {
                            relatedAttachmentOutputValue = relatedAttachmentOutputValue.concat(item.value.data);
                        }
                    }
                });
                field.relatedAttachmentInputValues = relatedAttachmentInputValues;
                field.relatedAttachmentOutputValue = relatedAttachmentOutputValue;
            });
        }

        function sendDocumentOpenedEvent() {
            var target = {
                id: vm.currentData.documentId,
                name: vm.currentData.documentName,
                type: vm.currentData.nodeType,
                levelType: vm.currentData.levelType,
                defaultFieldView: vm.currentData.defaultFieldView
            };
            broadcastService(broadcastType.documentOpenedTarget, target);
        }

        function showSidebarFields() {
            vm.isToggleSidebarFields = true;
        }

        function hideSidebarFields() {
            vm.isToggleSidebarFields = false;
        }

        function executeDocumentTypeIfNeeded() {
            if (vm.currentData.type == E.documentTypes.LinkDocument) {
                openUrlDocument();
            }

            if (vm.currentData.type == E.documentTypes.FileDocument) {
                openFileDocument();
            }
        }

        function openUrlDocument() {
            var urlLink = vm.currentData.url;
            if (vm.currentData.url != null && vm.currentData.url.length > 3) {
                if (vm.currentData.url.substring(0, 3) == 'www') {
                    urlLink = 'http://' + vm.currentData.url;
                }
            }
            window.open(urlLink, '_blank');
        }

        function runServicesAfterInit() {
            updateLocalAnchors();
        }

        function openFileDocument() {
            if (!vm.enableOpenDocumentOnline)
                window.open(handbookRequests.GetFileDocumentRequest + vm.currentData.entityId, '_blank');
        }

        function compareDocument() {
            window.open(String.format('/document/{0}/compareWithEarlierVersion', vm.currentData.documentId), '_blank');
        }

        function registDeviationWithDocument() {
            window.open(vm.deviationUrl + vm.documentDeviationCategoryLink + '?documentRelatedId=' + vm.currentData.documentId, '_blank');
        }

        function fullScreen() {
            if (vm.isFullScreen) {
                documentService.showFullscreen();
            } else {
                documentService.showNormal();
                tabStateService.adjustContentHeightPosition(tabStateType.documentTabState);
                $('#document-content-identifier').css('margin-top', '0px');
            }
            vm.isFullScreen = !vm.isFullScreen;
            setTimeout(function () {
                var height = $('#document-content-identifier').height();
                stickyTitle(height);
                if (isIE) {
                    runInitforIE(height);
                }
            }, 500);
        }

        function linkToDocumentManagement() {
            var backendUrl = HandbookConfiguration.BackendURL;
            var lastChar = backendUrl.charAt(backendUrl.length - 1);
            var commonAdd = lastChar == '/' ? '' : '/';
            if (vm.backendIsDb4) {
                var url = backendUrl + '&documentId=' + vm.documentId;
                url = url.replace('gk=2', 'gk=1');
                window.open(url, '_blank');
            } else {
                window.open(backendUrl + commonAdd + 'document/' + vm.documentId, '_blank');
            }
        }

        function getNextSearchResultByEnter(keyEvent) {
            if (keyEvent.which == 13) {
                navForward();
            }
        }

        $scope.$on(broadcastType.linkToDocumentManagement, function (e, target) {
            linkToDocumentManagement();
        });

        $scope.$on(broadcastType.toggleDocumentFullscreen, function (e, target) {
            fullScreen();
        });

        function fullScreenInit() {
            if (angular.element('#handbook-nav:visible').length == 0) {
                documentService.showFullscreen();
                vm.isFullScreen = false;
            } else {
                documentService.showNormal();
                vm.isFullScreen = true;
            }
        }

        function processEmbedUrl() {
            if (vm.isEmbedUrl) {
                if (vm.typeHideHeader) {
                    angular.element('#documentHeader1Container').hide();
                    angular.element('#fieldTitle').hide();
                }
            }
        }

        function moveToDefaultField(hash) {
            var hashTemp = hash.split('#p');
            if (hashTemp.length < 1) {
                var elmnt = document.getElementById(hash.split('#')[1]);
                if (elmnt) elmnt.scrollIntoView();
                return;
            }

            var field = vm.currentData.fieldContents.find(function (x) {
                return x.fieldId == hashTemp[1];
            });
            if (field) {

                showContent(hashTemp[1], field)

            } else {
                var elmnt = document.getElementById(hash.split('#')[1]);
                if (elmnt) elmnt.scrollIntoView();
            }

        }

        function clearActive() {
            vm.activeRelatedDocuments = false;
            vm.activeAttachments = false;
            vm.activeLink = false;
            vm.activeFile = false;
            vm.activeAgreeFiles = false;

            for (var i = 0; i < vm.currentData.fieldContents.length; i++) {
                vm.currentData.fieldContents[i].activeField = '';
            }
        };

        function showContent(id, fieldContent) {
            isFieldActive = true;
            animationChangeBackgroundColor(id);
            clearActive();
            clearAnchorActive();
            if (fieldContent) {
                fieldContent.activeField = 'active';
            } else {
                if (String(id).indexOf('IdrelatedDocument') > -1)
                    vm.activeRelatedDocuments = true;
                else if (String(id).indexOf('Idattachment') > -1)
                    vm.activeAttachments = true;
                else if (String(id).indexOf('IdLink') > -1)
                    vm.activeLink = true;
                else if (String(id).indexOf('IdAgreeFildes') > -1) {
                    vm.activeAgreeFiles = true;
                }
                else
                    vm.activeFile = true;
            }

            setTimeout(function () {
                isFieldActive = false;
            }, 2000);
        };


        function showContentanchor(id, fieldContent, itemAnchor) {
            isFieldActive = true;
            clearActive();
            clearAnchorActive();
            if (fieldContent) {
                fieldContent.activeField = 'active';
                itemAnchor.activeField = 'active';
                let e = document.getElementById(itemAnchor.id);
                e.className += " activeAnchor";
                e.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth',
                    inline: 'start'
                });
            } else {
                if (String(id).indexOf('IdrelatedDocument') > -1)
                    vm.activeRelatedDocuments = true;
                else if (String(id).indexOf('Idattachment') > -1)
                    vm.activeAttachments = true;
                else if (String(id).indexOf('IdLink') > -1)
                    vm.activeLink = true;
                else if (String(id).indexOf('IdAgreeFildes') > -1) {
                    vm.activeAgreeFiles = true;
                }
                else
                    vm.activeFile = true;
            }
            
            setTimeout(function () {
                isFieldActive = false;
            }, 2000);
        };

        function clearAnchorActive() {
            vm.currentData.fieldContents.forEach((content) => {
                let anchors = content.fieldsAnchor;
                if (anchors) {
                    anchors = anchors.filter((x) => x.id != "");
                    if (anchors) {
                        anchors.forEach((anchor) => {
                            anchor.activeField = '';
                            let e = document.getElementById(anchor.id);
                            if (e) {
                                e.className -= " activeAnchor";
                            }
                        });
                    }
                }
            });
        };

        function getMousePosition() {
            return cursorY
        }

        function removeStickyTitle() {
            var title = document.querySelector('#documentTitle');
            title.classList.remove('sticky');
            $('#documentTitle').css('top', '');
            $('#documentTitle').css('width', '');
            $('#documentTitle').css('background-color', '');
            $('#documentTitle').css('margin-left', '');
            var placeholder = document.querySelector('#placeholderTitleId');
            if (placeholder != null) {
                title.parentNode.removeChild(placeholder);
            }
            document.querySelector('#document-content-identifier').classList.remove('scrolling');
            $('#document-content-identifier').unbind('scroll');
        }

        function animationChangeBackgroundColor(id) {
            id = String(id);
            var indexHash = id.indexOf('#');
            if (indexHash > 0) {
                id = id.substr(0, indexHash);
            }
            var hash = '#Id' + id;
            var elementId = '#Id' + id;
            if (id.indexOf('IdrelatedDocument') > -1 || id.indexOf('IdLink') > -1 || id.indexOf('IdFile') > -1 || id.indexOf('Idattachment') > -1
                || id.indexOf('IdAgreeFiles') > -1) {
                hash = '#' + id;
                elementId = '#' + id;
            }
            var $parentDiv = $('.document-detail');
            if ($(hash).position()) {
                $parentDiv.animate({ scrollTop: $(hash).position().top }, 'slow');
            }
            var $element = $(elementId);
            if ($element) {

                $element.animate({ backgroundColor: '#D7D7D7' }, 1500);
                $timeout(function () {
                    $element.css("background-color", "");
                }, 2000);
            }
        }

        function printAgreeFile(type) {
            if (type == 2) {
                window.open(String.format(handbookRequests.PrintPicoFormPdfRequest, vm.currentData.documentId, false), '_blank');
                return;
            }
            if (vm.currentData.knowledgeTypeId == KnowledgeType.shortVersionOfAgreeRequirements) {
                window.open(String.format(handbookRequests.PrintAgreeMethodReportShortVersionRequest, vm.currentData.documentId, false), '_blank');
                return;
            }
            window.open(String.format(handbookRequests.PrintAgreeMethodReportFullVersionRequest, vm.currentData.documentId, false), '_blank');
        }

        function feedbackDocument(positive) {
            var modalInstance = $uibModal.open({
                templateUrl: paths.FeedbackModalView,
                controller: controllers.feedbackController,
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    model: function () {
                        return {
                            entityId: vm.currentData.entityId,
                            positive: positive
                        };
                    }
                }
            });
        }

        function goToDocumentInPublicHandbook(documentId) {
            if (HandbookConfiguration.PublicURL && !vm.isPublishedVersion) {
                window.open(vm.documentPublishUrl, '_blank');
            }
        }

        function openAboutDocument() {
            var modalInstance = $uibModal.open({
                templateUrl: '/app/components/document/aboutDocumentModal.html',
                controller: 'AboutDocumentModalController as vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    model: function () {
                        return {
                            documentData: vm.currentData,
                            publishedVersion: vm.publishedVersion,
                            folderLinks: vm.FolderLinks,
                            enableElementsIntegration: vm.enableElementsIntegration,
                        };
                    }
                }
            });
        }

        function handleScrollInMobile() {
            setTimeout(function () {
                angular.element(document.querySelector('#documentDetailContainer')).bind('scroll', function () {
                    const contentWithLayoutTop = $('#topmenuMobile').position().top;
                    const topmenuMobileBottom = $('#documentHeader1Container').position().top + $('#documentHeader1Container').height();
                    if (contentWithLayoutTop < topmenuMobileBottom) {
                        angular.element('#documentHeader1Container').addClass('shadow-effect');
                        angular.element('#goHeadButton').removeClass('hide');
                    }
                    else {
                        angular.element('#documentHeader1Container').removeClass('shadow-effect');
                        angular.element('#goHeadButton').addClass('hide');
                    }
                })
            }, 0)
        }

        function scrollDocumentContentToTop() {
            var hash = '#topmenuMobile';
            var $parentDiv = $('.document-detail');
            if ($(hash).position()) {
                $parentDiv.animate({ scrollTop: $(hash).position().top }, 'slow');
                angular.element('#goHeadButton').addClass('hide');
            }
            
        }

        function addDocumetEmailSubscription() {
            var requestUrl = handbookRequests.AddEmailSubscriptionDocument + '/' + vm.currentData.documentId;
            $http.post(requestUrl)
                .then(function () {
                    vm.currentData.isEmailSubscribe = !vm.currentData.isEmailSubscribe;
                });
        };

        function setViewMode(viewMode) {
            vm.currentData.viewMode = viewMode;
            selectViewModeChange();
        }

        function adjustHeightDocument() {
            setTimeout(() => {
                var documentContentIdentifierHeight = $('#document-content-identifier').outerHeight();
                var reportMenuIconHeight = $('#reportMenuIcon').outerHeight();
                var documentFieldListNameHeight = $('#documentFieldListName').outerHeight();
                var documentFieldTitleHeight = $('#documentFieldTitle').outerHeight();
                var sum = documentContentIdentifierHeight - reportMenuIconHeight - documentFieldListNameHeight - documentFieldTitleHeight - 120;

                angular.element('#documentDetailFieldContentList').css({
                    maxHeight: (sum)
                });
            },0);
        }

        function goToProcessDetail(item) {
            if (vm.processClassificationTypes.Processes == item.processClassification) {
                return '/process-fe/process-detail/' + item.processNumber;
            }
            if (vm.processClassificationTypes.ProcessInterconnected == item.processClassification) {
                return '/process-fe/process-interconnected/' + item.processNumber;
            }
        }

        function popUpWasBlocked(popUp) {
            return !popUp || popUp.closed || typeof popUp.closed === 'undefined'
        }

        function openFileAttachOnline(entityId, documentName, isLastVersion, isOneDrive) {
            var endPoint = isOneDrive ? "/api/OneDrive/GetFileToOneDrive"  : "/api/OneDrive/GetFile";

            return $http.get(endPoint, { params: { entityId: entityId, documentName: documentName, isLastVersion: isLastVersion, showLoading: true } })
                .success(function (url) {
                    const w = window.open(url, '_blank')
                    if (popUpWasBlocked(w)) {
                        alert(globalResources.EnablePopupBrowser);
                    }

                });
        }

        function openFileDocumentOnline(entityId, documentName, isOneDrive) {
            var endPoint = isOneDrive ? "/api/OneDrive/GetFileDocumentToOneDrive" : "/api/OneDrive/GetFileDocument";

            return $http.get(endPoint, { params: { entityId: entityId, documentName: documentName, showLoading: true } })
                .success(function (url) {
                    const w = window.open(url, '_blank')
                    if (popUpWasBlocked(w)) {
                        alert(globalResources.EnablePopupBrowser);
                    }
                });
        }
    }

})();